import './target-free-email.ajscss';

import { isEmailValid } from '@agent/core/channel-digit/mail/util/mail-util';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './target-free-email.html';

const MODULE_NAME = 'transferTargetFreeEmail';

class TransferTargetFreeEmailCtrl implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public eventTargetChange: Function;

  // internal properties
  public targetFreeEmail: string;
  public valid: boolean = true;

  $onInit() {}

  emailValid(): boolean {
    return isEmailValid(this.targetFreeEmail);
  }

  onTargetChange(): void {
    this.valid = this.emailValid();
    if (this.valid) {
      this.eventTargetChange({ $event: { target: this.targetFreeEmail } });
    } else {
      this.eventTargetChange({ $event: { target: undefined } });
    }
  }
}

export class TransferTargetFreeEmail implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    eventTargetChange: '&',
  };
  controller = [TransferTargetFreeEmailCtrl];
}

export default MODULE_NAME;
